import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Modal, Button, Image } from "react-bootstrap";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { update_flag_block_vendoradmin,get_all_admin_pending_vendors,
  get_all_admin_active_vendors } from "../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";

export const SuperAdminBlockUser = (props) => {
  let dispatch = useDispatch();
  let history = useHistory();
  const [showBlockUser, seShowBlockUser] = useState(false);
  const [block, setBlock] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);

  const onFlagClick = (e) => {
    const vendor_id = props.data.vendor_id;
    const token = props.auth.user.accessToken;
    const formData = {
      blocked: {
        isBlocked: !block
      },
      has_admin_approved: !block ? false : true
    };
    dispatch(
      update_flag_block_vendoradmin(formData, vendor_id, token, callback)
    );
  };

  const callback = (e) => {
    handleCloseBlockUser();
    // window.location.reload()..;
    const token = props.auth.user.accessToken;
    Alert.success(
      `<h4>Vendor ${
        props.data &&
        props.data.vendor &&
        props.data.vendor.blocked &&
        props.data.vendor.blocked.isBlocked
          ? "Unblock"
          : "Block"
      } Successfully </h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
    if (props.actionCall === "pending") {
      dispatch(get_all_admin_pending_vendors(token));
      history.push("/superadminallpendingvendors");
      } else if (props.actionCall === "active") {
        dispatch(get_all_admin_active_vendors(token));
        history.push("/superadminallvendors");
      } else {
      return null;
    }

    //
  };

  useEffect(() => {
    setBlock(
      props.data &&
        props.data.vendor &&
        props.data.vendor.blocked &&
        props.data.vendor.blocked.isBlocked
    );
  }, [props.data]);

  return (
    <React.Fragment>
      <Button
        variant="link"
        className={`${
          props.data &&
          props.data.vendor &&
          props.data.vendor.blocked &&
          props.data.vendor.blocked.isBlocked
            ? "border-0 enIconBtn mr-3 " //action_icon_padding p-15px
            : "enIconBtn mr-3"
        }`}
        onClick={handleShowBlockUser}
      >
        <Image
          src={
            props.block
              ? require("../../../../assets/images/ActionImages/image/block.svg")
              : require("../../../../assets/images/UserManagement/BlockContact.svg")
          }
          alt="Block User"
          title="Block User"
          fluid
        />
      </Button>
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to{" "}
          {props.data &&
          props.data.vendor &&
          props.data.vendor.blocked &&
          props.data.vendor.blocked.isBlocked
            ? "Unblock"
            : "Block"}{" "}
          the user ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={onFlagClick}
            // handleCloseBlockUser={handleCloseBlockUser}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

SuperAdminBlockUser.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  update_flag_block_vendoradmin,
})(withRouter(SuperAdminBlockUser));
